module.exports = __webpack_public_path__ + "static/index/img/baikal-203.d638cef3.jpg";